import { connect } from 'react-redux';
import { compose, withState, withPropsOnChange, withHandlers } from 'recompose';
import { withRouter } from 'react-router';

import SubscriptionCharges from '../components/SubscriptionCharges';
import { getSubscriptionCharges } from '../reducers/subscriptionCharges';
import { fetchSubscriptionCharges, refundSubscriptionCharge } from '../actions';
import { getSubscriptionId } from '../reducers/subscription';
import withToggle from '../../../common/hoc/withToggle';
import { showNotification } from '../../../common/helpers/notifications';
import { ITEM_TYPE } from '../../../register/constants';

const mapStateToProps = state => ({
  subscriptionCharges: getSubscriptionCharges(state),
  subscriptionId: getSubscriptionId(state),
});

const mapDispatchToProps = {
  fetchSubscriptionCharges,
  refundSubscriptionCharge,
};

const enhance = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withToggle('refundModal'),
  withState('selectedCharge', 'setSelected', null),
  withHandlers({
    refund: props => async (charge, options) => {
      await props.refundSubscriptionCharge(
        props.subscriptionId,
        charge.id,
        options.amount
      );
      props.refundModalOff();
      props.setSelected(null);
      showNotification({
        title: 'SUCCESS',
        message: charge.maxRefundAmount < options.amount ?
          'Charge partially refunded' :
          'Charge was successfully refunded',
        level: 'success',
      });
    },
    openRefundModal: props => (charge) => {
      props.setSelected({
        id: charge.id,
        maxRefundAmount: charge.price - charge.refundedAmount,
        totalCost: charge.price,
        itemType: ITEM_TYPE.charge,
      });

      return props.refundModalOn();
    },
  }),
  withState('showForm', 'setShowForm', false),
  withPropsOnChange(['subscriptionId'], (props) => {
    if (props.subscriptionId) {
      return props.fetchSubscriptionCharges(props.subscriptionId);
    }
  }),
);

export default enhance(SubscriptionCharges);
